import gql from 'graphql-tag';
import {
  orderPartyFragments,
  orderDeliveryFragments,
  orderFragments,
  orderUnitSettingsDispaySettingFragments,
} from './Order';

export const emailLogsFragments = gql`
  fragment emailLogsFragments on LogInvoiceMail {
    id destination sentAt
    deliveryMethod
    sentBy { id name }
    deliveryStatus
    deliveryError
    attachmentsCount
  }
`;

export const logInvoiceOverdueNoticeMailFragments = gql`
  fragment logInvoiceOverdueNoticeMailFragments on LogInvoiceOverdueNoticeMail {
    id
    sentAt
    sentBy {
      id
      name
    }
    recipientMail
    deliveryStatus
    deliveryError
  }
`;

export const invoicePaymentMethodsFragments = gql`
  fragment invoicePaymentMethodsFragments on InvoicePaymentMethod {
    id
    name
    amount
  }
`;

export const invoiceOverdueNoticeFragments = gql`
  fragment invoiceOverdueNoticeFragments on InvoiceOverdueNotice {
    id
    issueDate
    dueDate
    additionalCharge
    orderNumber
  }
`;

export const invoiceFragments = gql`
  fragment invoiceFragments on Invoice {
    id
    number
    kid
    issueDate
    dueDate
    paidDate
    paymentTerm
    note
    reference
    isDeliveredToFb
    emailLogs {
      ...emailLogsFragments
    }
    supplierParty {
      ...orderPartyFragments
    }
    customerParty {
      ...orderPartyFragments
    }
    orderDelivery {
      ...orderDeliveryFragments
    }
    taxAmount
    lineExtensionAmount
    taxExclusiveAmount
    taxInclusiveAmount
    payableRoundingAmount
    payableAmount
    bban
    iban
    orders {
      ...orderFragments
    }
    unit {
      id
      isCompany
      ...orderUnitSettingsDispaySettingFragments
    }
    customer {
      id
      creditDays
      email
      efakturaEligible
      efakturaIdentifier
      unit {
        id
        canReceiveEhf3
      }
    }
    latestEfakturaSubmission {
      id
      humanStatus
      sendingStatus
      pending
      shipmentId
      errorMessage
      sentAt
    }
    invoicePaymentMethods {
      ...invoicePaymentMethodsFragments
    }
    invoiceOverdueNotices {
      ...invoiceOverdueNoticeFragments
    }
    legalNotes
    customNote
    interestNote
    attachments {
      id
      fileName
      url
    }
  },
  ${orderPartyFragments}
  ${orderDeliveryFragments}
  ${orderFragments}
  ${emailLogsFragments}
  ${orderUnitSettingsDispaySettingFragments}
  ${invoicePaymentMethodsFragments}
  ${invoiceOverdueNoticeFragments}
`;

export const CREATE_INVOICE = gql`
  mutation createInvoice(
    $orderIds: [ID!]!,
    $issueDate: Date!,
    $dueDate: Date!,
    $paymentTerm: String,
    $supplierPartyId: ID,
    $customerPartyId: ID,
    $orderDeliveryId: ID,
    $invoicePaymentMethods: [InvoicePaymentMethodCreate!]!,
    $payableRoundingAmount: Decimal!,
    $payableAmount: Decimal!,
    $legalNotes: [String!],
    $customNote: String,
    $attachments: [FileUpload!]!,
  ) {
    createInvoice(
      input: {
        invoice: {
          orderIds: $orderIds,
          issueDate: $issueDate,
          dueDate: $dueDate,
          paymentTerm: $paymentTerm,
          supplierPartyId: $supplierPartyId,
          customerPartyId: $customerPartyId,
          orderDeliveryId: $orderDeliveryId,
          invoicePaymentMethods: $invoicePaymentMethods,
          payableRoundingAmount: $payableRoundingAmount,
          payableAmount: $payableAmount,
          legalNotes: $legalNotes,
          customNote: $customNote,
          attachments: $attachments,
        }
      }
    ) {
      invoice {
        id
      }
    }
  }
`;

export const GET_INVOICE = gql`
  query invoice($id: ID!) {
    invoice(id: $id) {
      ...invoiceFragments
    }
  },
  ${invoiceFragments}
`;
